import { render, staticRenderFns } from "./MaterialsZgi.vue?vue&type=template&id=08280b1a&scoped=true&"
import script from "./MaterialsZgi.vue?vue&type=script&lang=js&"
export * from "./MaterialsZgi.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsZgi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MaterialsZgi.vue?vue&type=style&index=1&id=08280b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08280b1a",
  null
  
)

export default component.exports